import axios from '@/libs/api.request'

// 列表
export const apiUniqueVisitorList = data => {
  return axios.request({
    url: '/uniquevisitor/list',
    method: 'post',
    data
  })
}
